var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Collection, Property } from '@syncfusion/ej2-base';
import { RibbonCollection } from './ribbon-collection';
/**
 * Defines the ribbon group.
 */
export class RibbonGroup extends ChildProperty {
    /**
     * @param {Object} prop - Gets the property of Group.
     * @param {boolean} muteOnChange - Gets the boolean value of muteOnChange.
     * @returns {void}
     * @private
     */
    setProperties(prop, muteOnChange) {
        super.setProperties(prop, muteOnChange);
    }
}
__decorate([
    Property('')
], RibbonGroup.prototype, "keyTip", void 0);
__decorate([
    Property('')
], RibbonGroup.prototype, "launcherIconKeyTip", void 0);
__decorate([
    Collection([], RibbonCollection)
], RibbonGroup.prototype, "collections", void 0);
__decorate([
    Property('')
], RibbonGroup.prototype, "cssClass", void 0);
__decorate([
    Property('')
], RibbonGroup.prototype, "id", void 0);
__decorate([
    Property(false)
], RibbonGroup.prototype, "isCollapsed", void 0);
__decorate([
    Property(true)
], RibbonGroup.prototype, "isCollapsible", void 0);
__decorate([
    Property(false)
], RibbonGroup.prototype, "enableGroupOverflow", void 0);
__decorate([
    Property('')
], RibbonGroup.prototype, "groupIconCss", void 0);
__decorate([
    Property('')
], RibbonGroup.prototype, "header", void 0);
__decorate([
    Property('Column')
], RibbonGroup.prototype, "orientation", void 0);
__decorate([
    Property('')
], RibbonGroup.prototype, "overflowHeader", void 0);
__decorate([
    Property(0)
], RibbonGroup.prototype, "priority", void 0);
__decorate([
    Property(false)
], RibbonGroup.prototype, "showLauncherIcon", void 0);
